import { memo } from "react";

import { QuestionForMain } from "@/components/features/_layouts/island/main/question";

import { TextAreaField } from "@/components/ui/form/fields/text-area-field";

import { useCampaignExplanationForHost } from "./hooks";

export const QuestionExplanationForHost = memo(() => {
	const { voucherExplanationForHost, onSetExplanationForHost } = useCampaignExplanationForHost();

	return (
		<QuestionForMain
			required={true}
			title="キャンペーンの概要(スタッフ向け)"
			guide="キャンペーンの内容を伝える紹介文を書きましょう。(スタッフ向け)"
			inputChildren={
				<TextAreaField
					errorMessage={voucherExplanationForHost?.error}
					value={voucherExplanationForHost?.value ?? undefined}
					handleChange={onSetExplanationForHost}
				/>
			}
		/>
	);
});

QuestionExplanationForHost.displayName = "QuestionExplanationForHost";
